export default {
    home: "/",
    aboutUs: "/about-us",
    privacyPolicy: "/privacy-policy",
    platformGuidelines: "/platform-guidelines",
    termsAndConditions: "/terms-and-conditions",
    advisoryBoard: "/members/advisory-board",
    advisoryBoardChairman: "/members/advisory-board/chairman",
    advisoryBoardDeputyChairman: "/members/advisory-board/chairman#deputy",
    advisoryBoardMembers: "/members/advisory-board/board-members",
    membership: "/members",
    newMember: "/members/new-membership",
    currentMembers: "/members/current",
    currentMembersMap: "/members/map",
    innovationAreas: "/innovation-areas",
    corporateMembership: "/members/corporate-membership",
    corporateMembershipBrochure: "https://www.globalwaterintel.com/static_file_containers/465",
    corporateMembers: "/members/corporate",
    events: "/events",
    eventSponsors: "/events/sponsors",
    contactUs: "/contact-us",
    yourAccount: "/users/your-account",
    messages: "/users/messages",
    foundationPartner: "/members/corporate-membership/foundation-partner",
    pressReleases: "/press-releases",
    eventsOverview: "/events/overview",
    workshops: "/events/workshops",
    digitalBrochure: "https://www.globalwaterintel.com/static_file_containers/464"
};



// WEBPACK FOOTER //
// ./src/util/hyperlinks.js